import { Widget } from '../../../components/Widgets/constants';

export const ACCOUNTS_TO_REMOVE_WIDGETS_FOR = [
  {
    account: 'birminghamhousing',
    widgets: [
      Widget.PROJECT_BUDGET_SUMMARY, // DevelopmentPipelineWidget
      Widget.DEVELOPER_INVESTMENT, // DevelopersInvestmentWidget
      Widget.CITY_INVESTMENT, // CityInvestmentWidget
      Widget.PROJECTS_SUMMARY_REPORT, // StatusWidget
      Widget.PROJECT_STATUS_SUMMARY, // ProjectStatusSummaryWidget
      Widget.PROJECT_FINANCIAL, // ProgramFinancialWidget
      Widget.PROJECTS_BY_PROJECT_TYPE, // ProjectTypeWidget
      Widget.PROJECTS_BY_USES, // TotalProjectUsesWidget
    ],
  },
  {
    account: '6ede42509c95',
    widgets: [
      Widget.CITY_INVESTMENT, // CityInvestmentWidget
      Widget.DEVELOPER_INVESTMENT, // DevelopersInvestmentWidget
      Widget.PROJECTS_SPENDING_SUMMARY_REPORT, // SourceSpentWidget
      Widget.NEW_CONSTRUCTION_SUMMARY, // NewConstructionSummaryWidget
      Widget.PROJECTS_BY_NEIGHBORHOOD, // NeighborhoodImpactWidget
      Widget.PROJECTS_SUMMARY_REPORT, // ProjectStatusWidget
    ],
  },
];

export const shouldRenderWidget = (widgetName: Widget, account: string | undefined): boolean => {
  if (!account) {
    return true;
  }

  const accountConfig = ACCOUNTS_TO_REMOVE_WIDGETS_FOR.find((config) => config.account === account);

  if (!accountConfig) {
    return true;
  }

  return !accountConfig.widgets.includes(widgetName);
};
